import { formatDistanceToNow } from "date-fns";
import { cs, enUS } from "date-fns/locale";
import { useTranslations } from "@/composables/useTranslations";

export const useDashboardRelativeTime = () => {
    const { locale } = useTranslations();

    const formatRelativeTime = (isoDate: string): string =>
        formatDistanceToNow(new Date(isoDate), {
            addSuffix: true,
            locale: locale.value === "cs" ? cs : enUS,
        });

    return { formatRelativeTime };
};
